import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './i18n';
import './index.css';
import App from './App';
import { CartProvider } from 'context/CartContext';
import { StoreProvider } from 'context/StoreContext';
import { applyTheme, loadFonts } from 'theme';
import { DEFAULT_STORE } from 'utils/defaultStore';
import { readCachedStore } from 'utils/storeProfile';
import { startSnapshotHandoff } from 'utils/snapshotHandoff';

const serverTheme = document.getElementById('mxc-theme');
if (serverTheme) {
  // The SEO Edge Function inlined the shop's current theme: keep it (the
  // cache may be older) and start its two fonts right away.
  loadFonts((serverTheme.dataset.fonts || '').split(/\s+/).filter(Boolean));
} else {
  // Paint the first frame with the last known branding (or the default
  // preset) and start its two fonts, before React renders anything.
  const initialTheme = (readCachedStore() || DEFAULT_STORE).theme;
  applyTheme(initialTheme);
  loadFonts([initialTheme.typography.heading, initialTheme.typography.body]);
}

// Keep showing a server-rendered snapshot until the page is ready (see
// utils/snapshotHandoff.js).
const rootElement = document.getElementById('root');
startSnapshotHandoff(rootElement);

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <StoreProvider>
        <CartProvider>
          <App />
        </CartProvider>
      </StoreProvider>
    </BrowserRouter>
  </StrictMode>
);
